import { useTranslation } from 'react-i18next';

export const ViabilityPercentage = ({ viability }: { viability: number }) => {
  const { t } = useTranslation();

  return (
    <div className="flex">
      <div className="w-60">
        <div className="text-gray-600 text-xl font-bold">
          {t('measurements.viability')}
        </div>
        <div className="font-normal">(% of cells viable)</div>
      </div>
      <div className="text-gray-600 text-3xl font-bold">{viability.toFixed(2)}</div>
    </div>
  );
};
